import Media, { formatMinutes } from './Media';

export { formatMinutes };
export default Media;
